import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvChemistryNgLibModule } from 'sv-chemistry-ng-lib';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SvChemistryNgLibModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: []
})
export class SharedModule { }
